import { Component, OnInit } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { ActivatedRoute } from "@angular/router";
import { fuseAnimations } from "@fuse/animations";
import { FuseConfirmDialogComponent } from "@fuse/components/confirm-dialog/confirm-dialog.component";
import { UiService } from "app/helper-components/UiService";
import { HelperService } from "app/helpers/helper.service";
import { PostService } from "app/helpers/post.service";
import { environment } from "environments/environment";
import { MeetingChecklistComponent } from "../meeting-checklist/meeting-checklist.component";

@Component({
  selector: "app-appointment-progress",
  templateUrl: "./appointment-progress.component.html",
  styleUrls: ["./appointment-progress.component.scss"],
  // encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations,
})
export class AppointmentProgressComponent implements OnInit {
  state = 0;
  confirmDialogRef: MatDialogRef<FuseConfirmDialogComponent>;
  dialogRef: any;
  parameters: any;
  const_id: any;
  showProgress = false;
  appointments: any;
  appointmentsId: any;

  // _matDialog: any;

  constructor(
    private _matDialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private helper: HelperService,
    private postService: PostService,
    private uiService: UiService
  ) {}

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((val) => {
      this.parameters = this.helper.getParameters(val["_v"]);
      if (!this.parameters) {
        this.activatedRoute.queryParams.subscribe((data) => {
          this.parameters = this.helper.getParameters(data["_v"]);
        });
      }
    });

    this.const_id = this.parameters.const_id;

    const formData = new FormData();
    formData.append("getCurrentAppointment", "1");
    formData.append("place_id", this.const_id);
    formData.append("subgroup_id", "5");

    this.postService
      .post(environment.API_APPOINTMENTS, formData)
      .subscribe((val) => {
        if (val.status == "success") {
          this.appointmentsId = val.data[0].appointment_id;

          this.showProgress = true;
        } else {
          this.showProgress = false;
        }
      });
  }

  kalanthaivu(): void {
    this.uiService.showLoading();

    const formData = new FormData();
    formData.append("getAppointments", "1");
    formData.append("appointment_id", this.appointmentsId);

    this.postService
      .post(environment.API_APPOINTMENTS, formData)
      .subscribe((val) => {
        var appointmentsData = val.data;
        appointmentsData.parameters = this.parameters;
        if (val.status == "success") {
          this.dialogRef = this._matDialog.open(MeetingChecklistComponent, {
            panelClass: "event-form-dialog",
            data: appointmentsData,
          });

          this.uiService.showLoading();
        } else {
        }
      });
  }
}
